import { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField,
  Box, IconButton, Stack, Typography,
} from '@mui/material';
import { Icon } from '@iconify/react';

const ICON_OPTIONS = [
  'mdi:video-outline', 'mdi:file-document-edit-outline', 'mdi:book-open-page-variant',
  'mdi:headset', 'mdi:cellphone', 'mdi:trophy-outline', 'mdi:star', 'mdi:school',
  'mdi:clock-outline', 'mdi:chart-line', 'mdi:target', 'mdi:lightbulb-outline',
];

export default function FeaturesEditor({ open, onClose, features, onSave }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (open) setItems(features.map(f => ({ ...f })));
  }, [open, features]);

  const update = (i, field, val) => {
    const copy = [...items];
    copy[i] = { ...copy[i], [field]: val };
    setItems(copy);
  };

  const add = () => setItems([...items, { icon: 'mdi:star', title: '', description: '' }]);
  const remove = (i) => setItems(items.filter((_, idx) => idx !== i));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 800 }}>✏️ Edit Features</DialogTitle>
      <DialogContent>
        {items.map((item, i) => (
          <Box key={i} sx={{ p: 2, mb: 1.5, borderRadius: 2, border: '1px solid #e5e7eb', background: '#fafafa' }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
              <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#666' }}>
                Feature {i + 1}
              </Typography>
              <IconButton size="small" onClick={() => remove(i)} sx={{ color: '#ef4444' }}>
                <Icon icon="mdi:delete" />
              </IconButton>
            </Stack>
            <Stack direction="row" spacing={1} mb={1.5} flexWrap="wrap" useFlexGap>
              {ICON_OPTIONS.map(ic => (
                <IconButton key={ic} size="small" onClick={() => update(i, 'icon', ic)}
                  sx={{
                    border: item.icon === ic ? '2px solid #4338ca' : '1px solid #ddd',
                    borderRadius: 1.5, p: 0.8,
                    background: item.icon === ic ? 'rgba(67,56,202,0.08)' : '#fff',
                  }}>
                  <Icon icon={ic} style={{ fontSize: 20, color: item.icon === ic ? '#4338ca' : '#888' }} />
                </IconButton>
              ))}
            </Stack>
            <Stack direction="row" spacing={1.5}>
              <TextField size="small" label="Title" fullWidth value={item.title}
                onChange={e => update(i, 'title', e.target.value)} />
              <TextField size="small" label="Description" fullWidth value={item.description}
                onChange={e => update(i, 'description', e.target.value)} />
            </Stack>
          </Box>
        ))}
        <Button startIcon={<Icon icon="mdi:plus" />} onClick={add}
          sx={{ mt: 1, textTransform: 'none', fontWeight: 700 }}>
          Add Feature
        </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={() => onSave(items)}
          sx={{ background: 'linear-gradient(135deg, #4338ca, #6366f1)', fontWeight: 700 }}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
